var fromHtmlEntities = function (string) {
    return (string + "").replace(/&#\d+;/gm, function (s) {
        return String.fromCharCode(s.match(/\d+/gm)[0]);
    })
};

function initListing(parent, initialPage, tags, allTags, sort, category) {
    var numFilters = 0;

    // Listing app
    const Listing = Vue.createApp({
        data() {
            return {
                //defaults
                results: [],
                numResults: 0,
                numPages: 1,
                currentPage: initialPage,
                parent: parent,
                tags: tags, // todo: make tags URL encoded
                sort: sort,
                category: category,
                allTags: allTags
            };
        },
        methods: {
            fetchResults: function () {
                let t = this;
                const qs = `&page=${t.currentPage}&tags=${encodeURI(fromHtmlEntities(t.tags)).replace("&amp;", "%26")}&sort=${t.sort}&category=${t.category}`;
                this.navigate(qs);
                if (numFilters++ !== 0) {
                    history.pushState({ qs: qs, sort: t.sort, category: t.category }, 'page', `?parent=${t.parent}${qs}`);
                }
                else {
                    history.replaceState({ qs: qs, sort: t.sort, category: t.category }, 'page', `?parent=${t.parent}${qs}`);
                }
            },
            navigate: function (qs, sort, category) {
                let t = this;
                // get the results
                $.getJSON(`/umbraco/api/newslistingapi/getlisting?parent=${t.parent}${qs}`, function (data) {
                    t.results = data.results;
                    t.numResults = data.numResults;
                    t.numPages = data.numPages;
                    t.currentPage = data.currentPage;

                    // move newsletter cta within listing
                    setTimeout(function () {
                        //const half = Math.floor($('.listing-result').length / 2);
                        const third = 3;
                        $('.listing-result:nth-of-type(' + third + ')').after($('#newsletter-cta'));
                    }, 0);

                });

                // make dropdown selections
                if (sort !== undefined) t.sort = sort;
                if (category !== undefined) t.category = category;
            },
            changeCategory: function (category) {
                if (this.category === category) this.category = '';
                else this.category = category;
                this.go(1);
            },
            changeSort: function (sort) {
                if (this.sort === sort) this.sort = '';
                else this.sort = sort;
                this.go(1);
            },
            go: function (n) {
                // switch to page n
                this.currentPage = n;
                this.fetchResults();
            },
            toggleTag: function (tag) {
                let lowercaseTag = tag.toLowerCase();

                if (this.tags === lowercaseTag) {
                    this.tags = '';
                }
                else {
                    this.tags = lowercaseTag;
                }
                this.page = 1;
                this.fetchResults();
            }
        },
        created: function () {
            this.fetchResults();
        }
    });
    const vm = Listing.mount('#listing');

    // move featured story above listing
    $('#featured-story').appendTo('#featured-story-holder');


    // back/forward buttons
    $(window).on("popstate", function () {
        if (history.state) {
            vm.navigate(history.state.qs, history.state.sort, history.state.category);
        }
    });

    $('.mob-filters .sorts .item').click(function (e) {
        e.preventDefault();
        vm.changeSort($(this).data('val'));
    });

    $('.mob-filters .types .item').click(function (e) {
        e.preventDefault();
        vm.changeCategory($(this).data('val'));
    });

}